var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "119px",
    height: "123px",
    viewBox: "0 0 119 123",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "53") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "57.2168259%",
    y1: "5.83023215%",
    x2: "51.8766963%",
    y2: "41.3609782%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606673",
    stopOpacity: 0,
    offset: "0.289017%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373C47",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "18.0651159%",
    y1: "5.83023215%",
    x2: "12.7249863%",
    y2: "41.3609782%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606673",
    stopOpacity: 0,
    offset: "0.289017%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373C47",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "35.3395079%",
    y1: "64.113153%",
    x2: "48.1099504%",
    y2: "14.6396861%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C80AA",
    stopOpacity: 0,
    offset: "0.289017%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D6A86",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.4050961%",
    y1: "82.8703704%",
    x2: "53.5497262%",
    y2: "15.85097%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314F91",
    stopOpacity: 0,
    offset: "0.289017%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#324264",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0079911%",
    y1: "3.48101266%",
    x2: "50.0079911%",
    y2: "59.6518987%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969EAE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0159795%",
    y1: "3.48101266%",
    x2: "50.0159795%",
    y2: "59.4936709%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969EAE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "70.3526257%",
    y1: "9.56130484%",
    x2: "45.8039866%",
    y2: "58.3802025%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969EAE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Style-01",
    transform: "translate(-539.000000, -2740.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 53,
    transform: "translate(539.900000, 2740.343652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.11,44.7363483 C106.222,44.7363483 107.935,43.0263483 107.935,40.9063483 C107.935,38.7963483 106.222,37.0863483 104.11,37.0863483 C101.998,37.0863483 100.286,38.7963483 100.286,40.9063483 C100.286,43.0263483 101.998,44.7363483 104.11,44.7363483 Z",
    id: "Path",
    fill: "#EAEEF9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.517,65.4363483 C3.906,65.4363483 5.033,64.3163483 5.033,62.9163483 C5.033,61.5263483 3.906,60.4063483 2.517,60.4063483 C1.127,60.4063483 -5.68434189e-14,61.5263483 -5.68434189e-14,62.9163483 C-5.68434189e-14,64.3163483 1.127,65.4363483 2.517,65.4363483 Z",
    id: "Path",
    fill: "#EAEEF9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.083,110.716348 C15.473,110.716348 16.599,109.586348 16.599,108.196348 C16.599,106.806348 15.473,105.676348 14.083,105.676348 C12.693,105.676348 11.567,106.806348 11.567,108.196348 C11.567,109.586348 12.693,110.716348 14.083,110.716348 Z",
    id: "Path",
    fill: "#EAEEF9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B7BFCD",
    fillRule: "nonzero",
    points: "27.533 110.716348 62.842 99.6563483 62.842 54.2863483 27.533 65.2663483"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#6D7C9A",
    fillRule: "nonzero",
    opacity: 0.4,
    points: "98.151 110.716348 62.842 99.6563483 62.842 54.2863483 98.151 65.2663483"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.13,
    transform: "translate(27.100000, 53.656348)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-1)",
    points: "0.433 57.06 35.742 46 35.742 0.63 0.433 11.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-2)",
    points: "71.051 57.06 35.742 46 35.742 0.63 71.051 11.61"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EDF1F9",
    fillRule: "nonzero",
    points: "62.842 121.866348 27.533 110.796348 27.533 65.4363483 62.842 76.5063483"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DAE1ED",
    fillRule: "nonzero",
    points: "62.842 121.866348 98.151 110.796348 98.151 65.4363483 62.842 76.5063483"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero",
    opacity: 0.09,
    points: "54.842 113.866348 27.533 110.796348 27.533 65.4363483 62.842 76.5063483"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero",
    opacity: 0.2,
    points: "70.842 105.866348 98.151 110.796348 98.151 65.4363483 62.842 76.5063483"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DAE1ED",
    fillRule: "nonzero",
    points: "62.842 54.2863483 46.241 41.8663483 10.342 53.9463483 27.533 65.2663483"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DAE1ED",
    fillRule: "nonzero",
    points: "62.842 54.2863483 79.443 41.8663483 115.342 53.9463483 98.151 65.2663483"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EFF4FD",
    fillRule: "nonzero",
    points: "27.533 65.4363483 62.842 76.5063483 45.229 87.7363483 10.342 76.1663483"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EDF1F9",
    fillRule: "nonzero",
    points: "98.151 65.4363483 62.842 76.5063483 80.454 87.7363483 115.342 76.1663483"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.693,10.7463483 C77.64,24.1663483 79.114,27.1463483 79.598,40.3763483 C79.412,43.3963483 79.297,46.6763483 77.873,49.3263483 C75.972,53.3663483 71.322,56.1663483 66.929,56.2163483 C62.403,56.2963483 57.966,53.5263483 55.969,49.2463483 C54.563,46.6563483 54.608,43.1063483 56.535,40.7563483 C58.631,38.4963483 62.317,37.9363483 64.969,39.3463483 C67.886,40.6863483 69.627,43.4763483 70.271,46.4063483 C70.916,49.3463483 70.633,52.5363483 69.846,55.4363483 C68.2,62.4763483 66.836,62.8263483 62.799,74.7563483",
    id: "Path",
    stroke: "#ABB5CC",
    strokeWidth: 2,
    strokeDasharray: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.714,3.6363483 C78.702,5.6063483 76.865,6.8163483 74.536,6.1863483 C72.083,5.7663483 70.347,5.3363483 70.235,3.5763483 C70.291,1.7663483 72.263,1.0663483 74.57,0.2663483 C77.337,-0.8336517 78.557,1.7063483 78.714,3.6363483 Z",
    id: "Path",
    fill: "#DAE2EB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.865,9.6763483 C64.108,10.9563483 66.728,11.3263483 68.005,9.3663483 C69.406,7.2063483 70.604,5.6263483 69.317,4.1863483 C68.074,2.9063483 66.864,3.7663483 64.097,4.8663483 C61.879,5.9963483 61.409,8.2663483 62.865,9.6763483 Z",
    id: "Path",
    fill: "#DAE2EB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6,1.5063483 C69.732,1.0263483 71.087,1.3763483 71.691,2.2963483 C71.949,2.5863483 72.251,3.0363483 72.341,3.3763483 C73.304,5.6263483 73.001,7.8563483 71.702,8.3763483 C70.279,9.1163483 68.319,7.8563483 67.569,5.7263483 C67.39,5.0563483 67.301,4.7263483 67.166,4.2163483 C67.021,3.0063483 67.469,1.9863483 68.6,1.5063483 C68.768,1.4663483 68.6,1.5063483 68.6,1.5063483 Z",
    id: "Path",
    fill: "#989FB0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-5)",
    fillRule: "nonzero",
    points: "16.599 37.7363483 14.409 37.7363483 14.409 35.5463483 12.532 35.5463483 12.532 37.7363483 10.342 37.7363483 10.342 39.6763483 12.532 39.6763483 12.532 41.8663483 14.409 41.8663483 14.409 39.6763483 16.599 39.6763483"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-6)",
    fillRule: "nonzero",
    points: "21.41 92.6863483 19.22 92.6863483 19.22 90.4963483 17.343 90.4963483 17.343 92.6863483 15.152 92.6863483 15.152 94.6263483 17.343 94.6263483 17.343 96.8163483 19.22 96.8163483 19.22 94.6263483 21.41 94.6263483"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-7)",
    fillRule: "nonzero",
    points: "117.148 92.8063483 114.468 91.4563483 115.821 88.7763483 113.524 87.6163483 112.171 90.2963483 109.492 88.9363483 108.293 91.3163483 110.973 92.6663483 109.62 95.3463483 111.917 96.5063483 113.27 93.8263483 115.949 95.1763483"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox);
export default __webpack_public_path__ + "static/media/empty-box.3480040d780bfa2d82d52e2abb20fc0c.svg";
export { ForwardRef as ReactComponent };